const ClockRotateRight = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6459_37799)">
      <path d="M10 5L10 10L15 10" stroke="#8E33FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M18.2402 8.75016C17.6371 4.74078 14.1775 1.66683 10 1.66683C5.39763 1.66683 1.66667 5.39779 1.66667 10.0002C1.66667 14.6025 5.39763 18.3335 10 18.3335C13.4172 18.3335 16.354 16.2767 17.6399 13.3335"
        stroke="#8E33FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1667 13.3333H17.7333C18.0647 13.3333 18.3333 13.602 18.3333 13.9333V17.5"
        stroke="#8E33FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6459_37799">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ClockRotateRight;
